export default __webpack_public_path__ + "static/media/success-alert-icon.7ec52a10.svg";